import { get, post } from '@/utils/request'
import apiMap from "@/config";

const riskApi = apiMap.riskApi

export const getOrderList = data => post(`${riskApi}/risk/orderDownladTask/page`, data)

export const orderCancel = data => post(`${riskApi}/risk/orderDownladTask/cancel`, data)

